<script setup>
import SalesReviewReturnHeader from './SalesReviewReturnHeader.vue';

defineProps({
  transaction: { type: Object, required: true },
});
const emit = defineEmits(['back']);
</script>

<template>
  <SalesReviewReturnHeader
    read-only
    :transaction="transaction"
    @back="emit('back')"
  />
</template>
